import BrowseStateDefinition from '../BrowseStateDefinition';

function browseReducer(state = BrowseStateDefinition.getInitialState()) {
  // page (`/audio/music`) has no relevant interactivity
  return state;
}

export default browseReducer;
